import { render, staticRenderFns } from "./DoctorServiceModal.vue?vue&type=template&id=548d0e43"
import script from "./DoctorServiceModal.vue?vue&type=script&lang=js"
export * from "./DoctorServiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports